import React from 'react';
import PropTypes from 'prop-types';
import UserAvatar from '../../../assets/images/user.png';
function ReviewCard(_ref) {
  var resourceId = _ref.resourceId,
    projectResourceId = _ref.projectResourceId,
    name = _ref.name,
    projectName = _ref.projectName,
    reviewed = _ref.reviewed,
    rate = _ref.rate;
  return /*#__PURE__*/React.createElement("div", {
    className: "card box-shadow-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detail"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reviews-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "avatar"
  }, /*#__PURE__*/React.createElement("img", {
    src: UserAvatar,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "details"
  }, /*#__PURE__*/React.createElement("p", null, name), /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, /*#__PURE__*/React.createElement("span", {
    className: "badge small normal-font me-3"
  }, "$", rate, "/hr"))), /*#__PURE__*/React.createElement("div", {
    className: "action"
  }, /*#__PURE__*/React.createElement("a", {
    id: "review-single-alert",
    href: reviewed ? "/projects/".concat(projectResourceId, "/reviews/").concat(resourceId) : "/projects/".concat(projectResourceId, "/reviews/new"),
    className: "btn btn-primary",
    role: "button"
  }, "Review"))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("p", {
    className: "user-description"
  }, projectName)));
}
ReviewCard.propTypes = {
  name: PropTypes.string.isRequired,
  rate: PropTypes.number.isRequired,
  reviewed: PropTypes.bool.isRequired,
  projectName: PropTypes.string.isRequired,
  projectResourceId: PropTypes.string.isRequired,
  resourceId: PropTypes.string
};
ReviewCard.defaultProps = {
  resourceId: ''
};
export default ReviewCard;